import type * as core from '../../../../../../../core'

export const query: core.mosaic.Widget.Query = {
  selection: {
    '{}': {
      name: 'Degree of Change by Department',
      type: 'charts',
      content: {
        '{}': {
          data: {
            '[]': [
              {
                '{}': {
                  name: 'Degree of Change',
                  values: {
                    '[]': [
                      {
                        '{}': {
                          name: 'High',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Advancement Communications / Marketing',
                                  y: {
                                    '#': {
                                      '@': 'highAdvancementCommunicationsMarketing',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Advancement Operations',
                                  y: {
                                    '#': {
                                      '@': 'highAdvancementOperations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Advancement Studies',
                                  y: {
                                    '#': {
                                      '@': 'highAdvancementStudies',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Alumni Engagement',
                                  y: {
                                    '#': {
                                      '@': 'highAlumniEngagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Alumni Relations',
                                  y: {
                                    '#': {
                                      '@': 'highAlumniRelations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Annual Giving',
                                  y: {
                                    '#': {
                                      '@': 'highAnnualGiving',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Campaign Operations',
                                  y: {
                                    '#': {
                                      '@': 'highCampaignOperations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Corporate Resources',
                                  y: {
                                    '#': {
                                      '@': 'highCorporateResources',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Development / Fundraising',
                                  y: {
                                    '#': {
                                      '@': 'highDevelopmentFundraising',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Development',
                                  y: {
                                    '#': {
                                      '@': 'highDevelopment',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Donor Relations and Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'highDonorRelationsAndStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Foundation Relations',
                                  y: {
                                    '#': {
                                      '@': 'highFoundationRelations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Major Gifts',
                                  y: {
                                    '#': {
                                      '@': 'highMajorGifts',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Planning Giving',
                                  y: {
                                    '#': {
                                      '@': 'highPlanningGiving',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Principal Gifts',
                                  y: {
                                    '#': {
                                      '@': 'highPrincipalGifts',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Development',
                                  y: {
                                    '#': {
                                      '@': 'highProspectDevelopment',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Medium',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Advancement Communications / Marketing',
                                  y: {
                                    '#': {
                                      '@': 'mediumAdvancementCommunicationsMarketing',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Advancement Operations',
                                  y: {
                                    '#': {
                                      '@': 'mediumAdvancementOperations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Advancement Studies',
                                  y: {
                                    '#': {
                                      '@': 'mediumAdvancementStudies',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Alumni Engagement',
                                  y: {
                                    '#': {
                                      '@': 'mediumAlumniEngagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Alumni Relations',
                                  y: {
                                    '#': {
                                      '@': 'mediumAlumniRelations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Annual Giving',
                                  y: {
                                    '#': {
                                      '@': 'mediumAnnualGiving',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Campaign Operations',
                                  y: {
                                    '#': {
                                      '@': 'mediumCampaignOperations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Corporate Resources',
                                  y: {
                                    '#': {
                                      '@': 'mediumCorporateResources',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Development / Fundraising',
                                  y: {
                                    '#': {
                                      '@': 'mediumDevelopmentFundraising',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Development',
                                  y: {
                                    '#': {
                                      '@': 'mediumDevelopment',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Donor Relations and Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'mediumDonorRelationsAndStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Foundation Relations',
                                  y: {
                                    '#': {
                                      '@': 'mediumFoundationRelations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Major Gifts',
                                  y: {
                                    '#': {
                                      '@': 'mediumMajorGifts',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Planning Giving',
                                  y: {
                                    '#': {
                                      '@': 'mediumPlanningGiving',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Principal Gifts',
                                  y: {
                                    '#': {
                                      '@': 'mediumPrincipalGifts',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Development',
                                  y: {
                                    '#': {
                                      '@': 'mediumProspectDevelopment',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                      {
                        '{}': {
                          name: 'Low',
                          points: {
                            '[]': [
                              {
                                '{}': {
                                  x: 'Advancement Communications / Marketing',
                                  y: {
                                    '#': {
                                      '@': 'lowAdvancementCommunicationsMarketing',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Advancement Operations',
                                  y: {
                                    '#': {
                                      '@': 'lowAdvancementOperations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Advancement Studies',
                                  y: {
                                    '#': {
                                      '@': 'lowAdvancementStudies',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Alumni Engagement',
                                  y: {
                                    '#': {
                                      '@': 'lowAlumniEngagement',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Alumni Relations',
                                  y: {
                                    '#': {
                                      '@': 'lowAlumniRelations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Annual Giving',
                                  y: {
                                    '#': {
                                      '@': 'lowAnnualGiving',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Campaign Operations',
                                  y: {
                                    '#': {
                                      '@': 'lowCampaignOperations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Corporate Resources',
                                  y: {
                                    '#': {
                                      '@': 'lowCorporateResources',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Development / Fundraising',
                                  y: {
                                    '#': {
                                      '@': 'lowDevelopmentFundraising',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Development',
                                  y: {
                                    '#': {
                                      '@': 'lowDevelopment',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Donor Relations and Stewardship',
                                  y: {
                                    '#': {
                                      '@': 'lowDonorRelationsAndStewardship',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Foundation Relations',
                                  y: {
                                    '#': {
                                      '@': 'lowFoundationRelations',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Major Gifts',
                                  y: {
                                    '#': {
                                      '@': 'lowMajorGifts',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Planning Giving',
                                  y: {
                                    '#': {
                                      '@': 'lowPlanningGiving',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Principal Gifts',
                                  y: {
                                    '#': {
                                      '@': 'lowPrincipalGifts',
                                    },
                                  },
                                },
                              },
                              {
                                '{}': {
                                  x: 'Prospect Development',
                                  y: {
                                    '#': {
                                      '@': 'lowProspectDevelopment',
                                    },
                                  },
                                },
                              },
                            ],
                          },
                        },
                      },
                    ],
                  },
                  xLabel: 'Department',
                  yLabel: 'Count',
                },
              },
            ],
          },
          type: 'bar.stacked',
        },
      },
    },
  },
  subqueries: {
    lowMajorGifts: {
      filter: {
        and: [
          {
            in: [
              'Major Gifts',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highMajorGifts: {
      filter: {
        and: [
          {
            in: [
              'Major Gifts',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowDevelopment: {
      filter: {
        and: [
          {
            in: [
              'Development',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highDevelopment: {
      filter: {
        and: [
          {
            in: [
              'Development',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowAnnualGiving: {
      filter: {
        and: [
          {
            in: [
              'Annual Giving',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highAnnualGiving: {
      filter: {
        and: [
          {
            in: [
              'Annual Giving',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumMajorGifts: {
      filter: {
        and: [
          {
            in: [
              'Major Gifts',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowPlanningGiving: {
      filter: {
        and: [
          {
            in: [
              'Planning Giving',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowPrincipalGifts: {
      filter: {
        and: [
          {
            in: [
              'Principal Gifts',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumDevelopment: {
      filter: {
        and: [
          {
            in: [
              'Development',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highPlanningGiving: {
      filter: {
        and: [
          {
            in: [
              'Planning Giving',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highPrincipalGifts: {
      filter: {
        and: [
          {
            in: [
              'Principal Gifts',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowAlumniRelations: {
      filter: {
        and: [
          {
            in: [
              'Alumni Relations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumAnnualGiving: {
      filter: {
        and: [
          {
            in: [
              'Annual Giving',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highAlumniRelations: {
      filter: {
        and: [
          {
            in: [
              'Alumni Relations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowAlumniEngagement: {
      filter: {
        and: [
          {
            in: [
              'Alumni Engagement',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highAlumniEngagement: {
      filter: {
        and: [
          {
            in: [
              'Alumni Engagement',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumPlanningGiving: {
      filter: {
        and: [
          {
            in: [
              'Planning Giving',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumPrincipalGifts: {
      filter: {
        and: [
          {
            in: [
              'Principal Gifts',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowAdvancementStudies: {
      filter: {
        and: [
          {
            in: [
              'Advancement Studies',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowCampaignOperations: {
      filter: {
        and: [
          {
            in: [
              'Campaign Operations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowCorporateResources: {
      filter: {
        and: [
          {
            in: [
              'Corporate Resources',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumAlumniRelations: {
      filter: {
        and: [
          {
            in: [
              'Alumni Relations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highAdvancementStudies: {
      filter: {
        and: [
          {
            in: [
              'Advancement Studies',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highCampaignOperations: {
      filter: {
        and: [
          {
            in: [
              'Campaign Operations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highCorporateResources: {
      filter: {
        and: [
          {
            in: [
              'Corporate Resources',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowFoundationRelations: {
      filter: {
        and: [
          {
            in: [
              'Foundation Relations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowProspectDevelopment: {
      filter: {
        and: [
          {
            in: [
              'Prospect Development',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumAlumniEngagement: {
      filter: {
        and: [
          {
            in: [
              'Alumni Engagement',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highFoundationRelations: {
      filter: {
        and: [
          {
            in: [
              'Foundation Relations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highProspectDevelopment: {
      filter: {
        and: [
          {
            in: [
              'Prospect Development',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowAdvancementOperations: {
      filter: {
        and: [
          {
            in: [
              'Advancement Operations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumAdvancementStudies: {
      filter: {
        and: [
          {
            in: [
              'Advancement Studies',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumCampaignOperations: {
      filter: {
        and: [
          {
            in: [
              'Campaign Operations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumCorporateResources: {
      filter: {
        and: [
          {
            in: [
              'Corporate Resources',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highAdvancementOperations: {
      filter: {
        and: [
          {
            in: [
              'Advancement Operations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowDevelopmentFundraising: {
      filter: {
        and: [
          {
            in: [
              'Development / Fundraising',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumFoundationRelations: {
      filter: {
        and: [
          {
            in: [
              'Foundation Relations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumProspectDevelopment: {
      filter: {
        and: [
          {
            in: [
              'Prospect Development',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highDevelopmentFundraising: {
      filter: {
        and: [
          {
            in: [
              'Development / Fundraising',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumAdvancementOperations: {
      filter: {
        and: [
          {
            in: [
              'Advancement Operations',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumDevelopmentFundraising: {
      filter: {
        and: [
          {
            in: [
              'Development / Fundraising',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowDonorRelationsAndStewardship: {
      filter: {
        and: [
          {
            in: [
              'Donor Relations and Stewardship',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highDonorRelationsAndStewardship: {
      filter: {
        and: [
          {
            in: [
              'Donor Relations and Stewardship',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumDonorRelationsAndStewardship: {
      filter: {
        and: [
          {
            in: [
              'Donor Relations and Stewardship',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    lowAdvancementCommunicationsMarketing: {
      filter: {
        and: [
          {
            in: [
              'Advancement Communications / Marketing',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Low',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    highAdvancementCommunicationsMarketing: {
      filter: {
        and: [
          {
            in: [
              'Advancement Communications / Marketing',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'High',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
    mediumAdvancementCommunicationsMarketing: {
      filter: {
        and: [
          {
            in: [
              'Advancement Communications / Marketing',
              {
                '??': [
                  {
                    '@.': '!impacted_groups',
                  },
                  {
                    '[]': [],
                  },
                ],
              },
            ],
          },
          {
            '=': [
              {
                '@.': '!degree_of_change',
              },
              'Medium',
            ],
          },
        ],
      },
      target: 'ent:!change_impacts:!change_impact',
      selection: {
        '@.': '!id',
      },
    },
  },
}
